import { render, staticRenderFns } from "./ViewProduct.vue?vue&type=template&id=1c6bb42a&scoped=true"
import script from "./ViewProduct.vue?vue&type=script&lang=ts"
export * from "./ViewProduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6bb42a",
  null
  
)

export default component.exports